function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.0249 12C7.95073 12 7.87823 12.022 7.81656 12.0632C7.7549 12.1044 7.70683 12.163 7.67845 12.2315C7.65006 12.3 7.64264 12.3754 7.65711 12.4482C7.67158 12.5209 7.70729 12.5877 7.75974 12.6402C7.81218 12.6926 7.879 12.7283 7.95174 12.7428C8.02449 12.7573 8.09989 12.7498 8.16841 12.7215C8.23693 12.6931 8.2955 12.645 8.3367 12.5833C8.37791 12.5217 8.3999 12.4492 8.3999 12.375C8.3999 12.2755 8.36039 12.1802 8.29007 12.1098C8.21974 12.0395 8.12436 12 8.0249 12Z",
    fill: props.fill,
    stroke: props.fill,
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.4L8 4",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }));
};
export default SvgWarning;